import React from 'react'
import PropTypes from "prop-types";
import { components } from 'react-select';
import AsyncSelect from 'react-select/async'
import {getFormInputCssClass, hasMessage} from "../../../util/FormUtil";
import {fetchResponseHandler,extractMessage} from "../../../util/FetchUtil";
import {DEFAULT_COUNTRY_CODE, PROP_NAME_COUNTRY,
    ReactSelectEmptyIndicatorSeparator, ReactSelectDropdownIndicator} from "./CountryInputComponent";
import {PROP_NAME_STATE} from "./StateInputComponent";
import {PROP_NAME_CITY} from "./CityInputComponent";

export const PROP_NAME_POSTAL_CODE = "postalCode";
export const PROP_NAME_IS_POSTAL_CODE_SABRIX = "isPostalCodeSabrix";

/**
 * Postal Codes are currently validated for the US, others countries are free form text.
 */
class PostalCodeInputComponent extends React.Component {

    constructor(props){
        super(props);
        this.checkRequired = this.checkRequired.bind(this);
        this.findLocation = this.findLocation.bind(this);
        this.findPostalCodeOptions = this.findPostalCodeOptions.bind(this);
        this.setDirty = this.setDirty.bind(this);
        this.setValue = this.setValue.bind(this);
        this.validate = this.validate.bind(this);

        const PROP_DATA = {};
        const {userDataInit: {address: {maxLengthPostalCode}}} = this.props;
        PROP_DATA[PROP_NAME_POSTAL_CODE] = { label: "Postal Code", maxLength: maxLengthPostalCode};
        this.PROP_DATA = PROP_DATA;
    }

    componentDidUpdate(prevProps) {
        const {data} = this.props;
        const prevData = prevProps.data;
        const countryCode = data[PROP_NAME_COUNTRY];
        const prevCountryCode = prevData[PROP_NAME_COUNTRY];
        
        if (countryCode !== prevCountryCode) {  // on Country change - reset the postal code (without eager validation)
            this.props.setFormState(
                { property: PROP_NAME_POSTAL_CODE, data: null, metadata: {dirty: false, valid: true} }
            );
        }
    }

    findPostalCodeOptions(input = '', callback) {
        const countryCode = this.props.data[PROP_NAME_COUNTRY] || DEFAULT_COUNTRY_CODE;

        this.props.userDataService.findPostalCodesByCountry({countryCode, input})
            .then(fetchResponseHandler)
            .then((postalCodes) => {
                let postalCodeOptions = [];
                if (postalCodes.data && postalCodes.data.length > 0) {
                    postalCodeOptions = postalCodes.data.map(function (value) {
                        return {value: value, label: value};
                    });
                }
                callback(postalCodeOptions);
            })
            .catch((e) => {
                const message = extractMessage(e);
                console.log("Error while looking up postalCodes: " + message);
            });
    }

    /**
     * For non-Sabix postal codes
     * If country and postal code are filled, but either city or state is not filled,
     * then try to automatically get city and state
     * Logic exists here as should only occur onBlur of Postal Code
     *
     * @param country
     * @param postalCode
     */
    findLocation(data) {
        const country = data[PROP_NAME_COUNTRY];
        const postalCode = data[PROP_NAME_POSTAL_CODE];
        const city = data[PROP_NAME_CITY];
        const stateCode = data[PROP_NAME_STATE];

        if (country && postalCode && (!city || !stateCode)) {
            this.props.userDataService.findLocation({country, postalCode})
                .then(fetchResponseHandler)
                .then((result) => {
                    const {found, cityShortName, stateShortName, stateLongName} = result;
                    if (found) {
                        const stateOptions = this.state.stateOptions;
                        const targetState = stateOptions && stateOptions.length > 0 ? stateShortName : stateLongName;
                        let args = [
                            {property: PROP_NAME_CITY, data: cityShortName, metadata: {dirty: true, valid: true}},
                            {property: PROP_NAME_STATE, data: targetState, metadata: {dirty: true, valid: true}}
                        ];
                        this.props.setFormState(args);
                    }
                })
                .catch((e) => {
                    const message = extractMessage(e);
                    console.log("Error occurs while looking up Location: " + message);
                });
        }
    };

    setValue(e){
        let value = typeof(e) === "string" ? e : e.target.value;
        this.validate(value);
    }

    validate(value){
        const {metadata, required, setFormState} = this.props;
        const postalCodePropInfo = this.PROP_DATA[PROP_NAME_POSTAL_CODE];
        // meta - reset everything
        const newMetadata = {valid: true, dirty: true, message: null};
        this.checkRequired(value, postalCodePropInfo, newMetadata, required);
        setFormState(
            {property: PROP_NAME_POSTAL_CODE, data: value, metadata: { ...newMetadata }}
        );
    }

    checkRequired(value, propInfo, metadata, required){
        metadata.valid = !required || (value && value.trim().length > 0);
        if (! metadata.valid){
            metadata.message = propInfo.label + " is required";
        }
        return metadata.valid;
    }

    setDirty(){
        const {data} = this.props;
        const isSabrixVerified = data[PROP_NAME_IS_POSTAL_CODE_SABRIX];
        if (!isSabrixVerified) {
            this.findLocation(data);
        }
        this.validate(data[PROP_NAME_POSTAL_CODE]);
    }

    render() {
        const { data, metadata, readOnly, required, disabled } = this.props;
        const postalCode = data[PROP_NAME_POSTAL_CODE] || '';
        const isPostalCodeSabrix = data[PROP_NAME_IS_POSTAL_CODE_SABRIX];
        const requiredClassName = required ? "" : " optional";
        const fieldClassNameAttr = getFormInputCssClass(metadata, PROP_NAME_POSTAL_CODE);

        const postalCodePropInfo = this.PROP_DATA[PROP_NAME_POSTAL_CODE];

        return (
            <div className="form-fields">
                <div className={"form-fields grid__col-md-6 grid__col-sm-12" + requiredClassName}>
                    <label htmlFor={PROP_NAME_POSTAL_CODE}>{postalCodePropInfo.label}</label>
                    {
                        isPostalCodeSabrix &&
                        <AsyncSelect
                            backspaceRemovesValue={true}
                            className={"select-input--large react-select-container" + fieldClassNameAttr}
                            //className='react-select-container'
                            classNamePrefix="react-select"
                            components={{ IndicatorSeparator: ReactSelectEmptyIndicatorSeparator,
                                DropdownIndicator: ReactSelectDropdownIndicator }}
                            defaultOptions={true}
                            isDisabled={readOnly || disabled}
                            loadOptions={this.findPostalCodeOptions}
                            noOptionsMessage={() => "No results found"}
                            onBlur={() => this.setDirty()}
                            onChange={(e) => this.setValue(e ? e.value : '')}
                            placeholder={"Select or Type..."}
                            value={[{value: postalCode, label: postalCode}]}
                        />
                    }
                    {
                        !isPostalCodeSabrix &&
                        <input
                            className={"text-input text-input--large responsive" + fieldClassNameAttr}
                            disabled={ readOnly || disabled ? "disabled" : null}
                            id={PROP_NAME_POSTAL_CODE}
                            maxLength={postalCodePropInfo.maxLength}
                            onChange={this.setValue}
                            onBlur={this.setDirty}
                            name={PROP_NAME_POSTAL_CODE}
                            type="text"
                            value={postalCode}
                        />
                    }
                    {
                        hasMessage(metadata, PROP_NAME_POSTAL_CODE) &&
                        <div className="error">{metadata[PROP_NAME_POSTAL_CODE].message}</div>
                    }
                </div>
            </div>
        );
    }
}

PostalCodeInputComponent.propTypes = {
    data: PropTypes.object.isRequired,
    isPostalCodeSabrix: PropTypes.object.isRequired,
    metadata: PropTypes.object.isRequired,
    readOnly: PropTypes.object,
    userDataService: PropTypes.object.isRequired,
    setFormState: PropTypes.func.isRequired,
    userDataInit: PropTypes.object.isRequired
};

export default PostalCodeInputComponent;